/**
 * Password reset and authentication scenarios
 */
export const AUTH_SCENARIOS = {
  RESET: 'reset',
  CONFIRM: 'confirm',
  MIGRATION: 'migration',
} as const;

/**
 * Validation scenarios for password reset flow
 */
export const VALID_SCENARIOS = [
  AUTH_SCENARIOS.RESET,
  AUTH_SCENARIOS.CONFIRM,
  AUTH_SCENARIOS.MIGRATION,
] as const;

/**
 * URL query parameter keys
 */
export const QUERY_PARAMS = {
  ACTION: 'action',
  CODE: 'code',
  EMAIL: 'email',
  MIGRATION: 'migration',
} as const;

/**
 * URL query parameter values
 */
export const QUERY_PARAM_VALUES = {
  RESET: 'reset',
  TRUE: 'true',
} as const;

/**
 * Authentication token types
 */
export const TOKEN_TYPES = {
  ACCESS_2FA: 'access_2fa',
  BEARER: 'Bearer',
} as const;

/**
 * Error codes for network and authentication failures
 */
export const ERROR_CODES = {
  NETWORK: 'ERR_NETWORK',
  NETWORK_ERROR: 'NETWORK_ERROR',
  FAILED: 'ERR_FAILED',
} as const;

/**
 * Timeout durations in milliseconds
 */
export const TIMEOUTS = {
  DEFAULT_TIMEOUT: 100,
  NAVIGATION_DELAY: 500,
  PASSWORD_RESET_SUCCESS: 2000,
  REDIRECT_TIMEOUT: 3000,
} as const;

/**
 * Token expiration settings
 */
export const TOKEN_EXPIRY = {
  DEFAULT_SECONDS: 3600,
} as const;

/**
 * JWT token properties
 */
export const JWT_PROPERTIES = {
  COGNITO_GROUPS: 'cognito:groups',
} as const;

/**
 * Redux action types for authentication
 */
export const AUTH_ACTIONS = {
  LOGOUT: 'auth/logout',
  AUTHENTICATE: 'auth/authenticate',
  COGNITO_AUTHENTICATE: 'auth/cognitoAuthenticate',
  LEGACY_TOKEN_REFRESHED: 'auth/legacyTokenRefreshed',
  COGNITO_TOKEN_REFRESHED: 'auth/cognitoTokenRefreshed',
} as const;

/**
 * Legacy login configuration
 */
export const LEGACY_LOGIN = import.meta.env.VITE_LEGACY_LOGIN;

export const LEGACY_LOGIN_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
} as const;

/**
 * Authentication methods
 */
export const AUTH_METHODS = {
  LEGACY: 'legacy',
  COGNITO: 'cognito',
} as const;

/**
 * Type definitions derived from constants
 */
export type AuthScenario = (typeof AUTH_SCENARIOS)[keyof typeof AUTH_SCENARIOS];
export type LegacyLoginStatus =
  (typeof LEGACY_LOGIN_STATUS)[keyof typeof LEGACY_LOGIN_STATUS];
export type AuthMethod = (typeof AUTH_METHODS)[keyof typeof AUTH_METHODS];
